import React from 'react';

import './Initials.scss';

export const Initials = ({ text, size = 32 }) => {
  return (
    <div className="initials-container" style={{ width: size, height: size }}>
      <span className="initials-text">{text.charAt(0).toUpperCase()}</span>
    </div>
  );
};
